<div class="valuation-tab-container">
  <div class="valuation-tab-top-action-container">
    <div class="valuation-filter-container">
      <div class="valuation-filter">
        <div class="valuation-peer-ticker">
          <label class="valuation-filter-label">Peers</label>
          <app-ticker-search
            [tickers]="selectedTickerIds"
            [onScreen]="true"
            [isComp]="true"
            (onSearchedTickerUpdate)="handleSearchTickerSelection($event)"
            [hasSearchIcon]="true"
            [disabled]="
              !isTickerFilterDataReady ||
              isTickerUpdationInProgress ||
              !isMetaReady
            "
            [suggestedTickers]="suggestedPeers"
            placeholder="&nbsp;Add Peers"
            maxSelectedTickerCount="10"
          ></app-ticker-search>
          <button
            nz-button
            class="on-screen-search__edit-btn"
            (click)="handleEditTickerClick()"
            [disabled]="
              !isTickerFilterDataReady ||
              isTickerUpdationInProgress ||
              !isMetaReady ||
              isUserSettingsInProgress
            "
          >
            Edit
          </button>
        </div>
      </div>
      <div class="valuation-filter">
        <div class="valuation-ratio-box">
          <app-lineitem-filter
            [options]="ratioLineItemsData"
            [selectedValue]="{}"
            [selectedOptionsId]="selectedRatioId"
            liFilterId="valuationChartsLI"
            [bottomBorderView]="true"
            [disabled]="
              !isMetaReady ||
              isUserSettingsInProgress ||
              !state ||
              !isLineItemDataReady
            "
            placeholder="&nbsp;Add Ratios"
            label="Ratios"
            [showButton]="true"
            (onValueChange)="onSearchedLi($event)"
            (onEditButtonClick)="handleEditLineItemsButtonClick()"
          ></app-lineitem-filter>
        </div>
      </div>
      <div class="valuation-filter">
        <va-period-filter
          [filterWidthVariation]="3"
          [periodData]="state ? state.period : undefined"
          [disabled]="
            !isMetaReady || isUserSettingsInProgress || !state || !state.period
          "
          (onApply)="handlePeriodApply($event)"
          [dataAvailable]="periodsWithAvailableData"
        ></va-period-filter>
      </div>
      <div class="valuation-filter">
        <app-revision-period-select
          [selectedRevision]="state ? state.revision : undefined"
          (onChange)="onRevisionChange($event)"
          [createChart]="'false'"
          [disabled]="
            !isMetaReady ||
            isUserSettingsInProgress ||
            !state ||
            !state.revision
          "
        ></app-revision-period-select>
      </div>
      <div>
        <app-single-select-dropdown
          (callback)="onScaleTypeChange($event)"
          label="Rebase to 100"
          [items]="scaleTypeList"
          width="118px"
          [selectedItem]="state ? state.scaleType : undefined"
          [disabled]="
            !isMetaReady ||
            isUserSettingsInProgress ||
            !state ||
            !state.scaleType
          "
        >
        </app-single-select-dropdown>
      </div>
    </div>
    <div class="valuation-cta-right-section">
      <div
        nz-popover
        nzPopoverTrigger="click"
        [nzPopoverContent]="downloadOptionsTemplate"
        [(nzPopoverVisible)]="downloadOptVisible"
        class="va-button va-icon-button va-button-outline va-button-outline--primary"
        [ngClass]="[
          downloadOptVisible ? 'va-button--active' : '',
          !isMetaReady || !chartReady ? 'va-button--disabled' : ''
        ]"
        nzPopoverPlacement="bottom"
        title="Download Chart"
      >
        <va-icon
          isFontAwesome="true"
          [name]="faArrowToBottom"
          class="va-button-icon"
        ></va-icon>
      </div>
      <ng-template #downloadOptionsTemplate>
        <div class="download-opt" (click)="downloadValue(4)">Print Chart</div>
        <hr class="solid" />
        <div (click)="downloadValue(0)" class="download-opt">Download PNG</div>
        <div (click)="downloadValue(1)" class="download-opt">Download JPEG</div>
        <div (click)="downloadValue(2)" class="download-opt">Download PDF</div>
        <div (click)="downloadValue(3)" class="download-opt">Download SVG</div>
        <hr class="solid" />
        <div (click)="onExport()" class="download-opt">Export Value</div>
      </ng-template>
    </div>
  </div>
  <div class="val-chart-display-section">
    <div class="val-chart-plotter-container">
      <nz-spin
        nzTip="Crunching numbers..."
        *ngIf="!state || !isMetaReady || !chartOptions"
        class="spinner spinner-box"
      >
      </nz-spin>
      <app-chart-plotter
        *ngIf="state && chartOptions"
        [chartType]="selectedChart"
        [dataToUse]="chartOptions"
        (chartDataSet)="chartDataSet()"
        (onChartInstance)="onChartInstance($event)"
      ></app-chart-plotter>
      <div
        *ngIf="state && chartOptions && chartReady"
        class="earning-display"
        [ngStyle]="{ bottom: chartInfoBottom }"
      >
        <div class="earning-bullet"></div>
        <span class="content">Earnings</span>
      </div>
    </div>
  </div>
</div>
